import * as React from 'react';

const FileIcon = (props) => (
  <svg width={62} height={62} fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <svg width="50" height="36" viewBox="0 0 50 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_i_19185_258258)">
        <path
          d="M0.664062 32.0774V3.91837C0.664062 1.97437 2.23999 0.398438 4.184 0.398438H16.7152C17.6483 0.398438 18.4048 1.15487 18.4048 2.08798C18.4048 3.0211 19.1612 3.77753 20.0943 3.77753H38.5391C40.4831 3.77753 42.059 5.35346 42.059 7.29747V32.0774C42.059 34.0214 40.4831 35.5973 38.5391 35.5973H4.184C2.23999 35.5973 0.664062 34.0214 0.664062 32.0774Z"
          fill="#FEC84B"
        />
      </g>
      <g filter="url(#filter1_i_19185_258258)">
        <path
          d="M38.748 35.5992H4.73774C2.40775 35.5992 0.720678 33.3761 1.34762 31.1321L6.21777 13.7002C6.6427 12.1792 8.02864 11.1274 9.60788 11.1274H29.6855C30.5899 11.1274 31.4233 10.6373 31.8629 9.84691C32.3025 9.05651 33.1359 8.56641 34.0403 8.56641H44.4366C46.7735 8.56641 48.4617 10.8019 47.8221 13.0496L42.1336 33.0425C41.7031 34.5555 40.3211 35.5992 38.748 35.5992Z"
          fill="#FFDF89"
        />
      </g>
      <path
        d="M38.748 35.5974H4.69245C2.37628 35.5974 0.691433 33.399 1.29352 31.1625L2.5636 26.4446C14.1104 27.2659 39.2664 25.9518 47.5157 14.125L42.1336 33.0408C41.7031 34.5537 40.3211 35.5974 38.748 35.5974Z"
        fill="#AA5213"
        fillOpacity="0.08"
      />
      <defs>
        <filter
          id="filter0_i_19185_258258"
          x="0.664062"
          y="0.398438"
          width="41.3945"
          height="35.1992"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.12638" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.900698 0 0 0 0 0.670833 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_19185_258258" />
        </filter>
        <filter
          id="filter1_i_19185_258258"
          x="1.21484"
          y="8.56641"
          width="46.7441"
          height="27.0332"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.12638" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.929952 0 0 0 0 0.741699 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_19185_258258" />
        </filter>
      </defs>
    </svg>
  </svg>
);
export default FileIcon;
